import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="py-8 px-4 bg-slate-900 text-white border-t border-white/5" data-id="element-85">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-86">
        <div className="mb-8" data-id="element-87">
          <span className="text-blue-400 font-black tracking-widest text-sm uppercase" data-id="element-88">
            GUIADIGITAL360 TM
          </span>
          <p className="text-slate-400 text-xs mt-2 font-bold uppercase tracking-tighter" data-id="element-89">
            Química Visual © {new Date().getFullYear()}
          </p>
        </div>

        <div className="flex gap-6 mb-8" data-id="element-90">
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-91">
            <Instagram size={20} data-id="element-92" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-93">
            <Mail size={20} data-id="element-94" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-95">
            <Globe size={20} data-id="element-96" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-slate-500 font-medium max-w-md" data-id="element-97">
          <p data-id="element-98">
            Descargo de responsabilidad: Los resultados pueden variar según cada
            docente, contexto institucional y modalidad de uso. El material es
            de carácter pedagógico y didáctico.
          </p>
        </div>
      </div>
    </footer>;
}